export default __webpack_public_path__ + "static/media/entertainment_1280.db68348a.webp";